import { call, put, take } from 'redux-saga/effects';

import {
    apiAction,
    pageContext
} from 'ctm-util-functions';

import { validateForm } from './utils';

/**
 * Saga for form validation and submission
 * @param {Object} action - The action that describes the requested validation and apiSchema for submission.
 */
export const validateAndSubmit = function* (action) {
    const isValid = yield call(validateForm, action);

    if (isValid) {
        // Set the page state to transitioning
        yield put({ type: 'SET_PAGE_VALUE', identifier: 'transitioningToNewPage', value: true });

        const { apiSchema, requestPayload } = action;
        yield put(
            apiAction(
                apiSchema,
                pageContext.getProps().pageState, // @todo this could be moved to apiAction creator
                [], // restArg, we assume all form submission should be POST, so no restArg
                apiSchema.baseUrlName, // Optional in apiSchema, default is journeyServiceUrl,
                requestPayload
            )
        );
        // pause the generator until api success
        yield take(`${apiSchema.requestAction}_SUCCESS`);

        // reset the transition state
        yield put({ type: 'SET_PAGE_VALUE', identifier: 'transitioningToNewPage', value: false });
    }
};
